"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.sort");
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.object.seal");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _editorForVue = require("@wangeditor/editor-for-vue");
var _BusinessSchool = require("@/api/operationManagement/BusinessSchool");
var _ossUpload = require("@/utils/ossUpload");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Editor: _editorForVue.Editor,
    Toolbar: _editorForVue.Toolbar
  },
  data: function data() {
    return {
      dialogVisible: false,
      conditionType: {},
      // 条件
      ruleForm: {
        classify: null,
        coverUrl: '',
        title: '',
        sort: null,
        viewed: null,
        content: '',
        enable: 1,
        id: null
      },
      rules: {
        title: [{
          required: true,
          message: '请输入课程标题',
          trigger: 'blur'
        }, {
          min: 1,
          max: 500,
          message: '长度在 1 到 100 个字符',
          trigger: 'blur'
        }],
        sort: [{
          type: 'number',
          required: true,
          message: '请输入排序'
        }],
        viewed: [{
          type: 'number',
          required: true,
          message: '请输入观看次数'
        }]
      },
      editor: null,
      toolbarConfig: {},
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            customUpload: function () {
              var _customUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(file, insertFn) {
                var pictureUrl, _t;
                return (0, _regenerator2.default)().w(function (_context) {
                  while (1) switch (_context.p = _context.n) {
                    case 0:
                      _context.p = 0;
                      _context.n = 1;
                      return (0, _ossUpload.uploadOSS)(file);
                    case 1:
                      pictureUrl = _context.v;
                      insertFn(pictureUrl);
                      _context.n = 3;
                      break;
                    case 2:
                      _context.p = 2;
                      _t = _context.v;
                      console.log('error ->', _t);
                    case 3:
                      return _context.a(2);
                  }
                }, _callee, null, [[0, 2]]);
              }));
              function customUpload(_x, _x2) {
                return _customUpload.apply(this, arguments);
              }
              return customUpload;
            }()
          }
        }
      },
      mode: 'default',
      // or 'simple'
      EditorOpen: false // 显示隐藏
    };
  },
  beforeDestroy: function beforeDestroy() {
    var editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
  methods: {
    onCreated: function onCreated(editor) {
      this.editor = Object.seal(editor);
      // 一定要用 Object.seal() ，否则会报错
    },
    open: function open(data) {
      this.conditionType = data;
      this.EditorOpen = true;
      /*
      接收data对象：
      type：add、editor（添加，编辑）
      name：名称
      id：id
      */
      this.ruleForm.classify = data.classify;
      if (data.type === 'add') {
        // console.log('添加')
      } else {
        this.getBusinessCollege(data.id);
      }
      this.dialogVisible = true;
    },
    onClose: function onClose() {
      this.ruleForm = {
        classify: null,
        coverUrl: '',
        title: '',
        sort: null,
        viewed: null,
        content: '',
        enable: 1,
        id: null
      };
      // this.editor.destroy() // 销毁编辑器实例
      this.$refs['ruleForm'].resetFields();
      this.dialogVisible = false;
      this.EditorOpen = false;
      // const editor = this.editor
      // if (editor == null) return
      // editor.destroy() // 组件销毁时，及时销毁编辑器
    },
    submitForm: function submitForm(formName) {
      var _this = this;
      if (!this.ruleForm.coverUrl) {
        this.$message({
          type: 'warning',
          message: '请上传图片!'
        });
        return;
      }
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this.conditionType.type === 'add') {
            _this.saveBusinessCollege();
          } else {
            _this.updateBusinessCollege();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(_ref) {
        var file, pictureUrl, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              file = _ref.file;
              _context2.p = 1;
              _context2.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context2.v;
              this.ruleForm.coverUrl = pictureUrl;
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              console.log('error ->', _t2);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function handleFileUpload(_x3) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    // 保存海报
    saveBusinessCollege: function () {
      var _saveBusinessCollege2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              _context3.n = 1;
              return (0, _BusinessSchool.saveBusinessCollege)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '添加成功'
                });
                this.onClose();
                this.$emit('refresh');
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function saveBusinessCollege() {
        return _saveBusinessCollege2.apply(this, arguments);
      }
      return saveBusinessCollege;
    }(),
    // 更新海报
    updateBusinessCollege: function () {
      var _updateBusinessCollege2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var params, res, _t4;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              _context4.n = 1;
              return (0, _BusinessSchool.updateBusinessCollege)(params);
            case 1:
              res = _context4.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '编辑成功'
                });
                this.onClose();
                this.$emit('refresh');
              }
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
              console.log(_t4);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function updateBusinessCollege() {
        return _updateBusinessCollege2.apply(this, arguments);
      }
      return updateBusinessCollege;
    }(),
    // 查询
    getBusinessCollege: function () {
      var _getBusinessCollege2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5(id) {
        var params, res, data, _t5;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              params = {
                id: id
              };
              _context5.n = 1;
              return (0, _BusinessSchool.getBusinessCollege)(params);
            case 1:
              res = _context5.v;
              if (res.code === 0) {
                data = res.data;
                this.ruleForm.id = data.id;
                this.ruleForm.classify = data.classify;
                this.ruleForm.coverUrl = data.coverUrl;
                this.ruleForm.title = data.title;
                this.ruleForm.sort = data.sort;
                this.ruleForm.viewed = data.viewed;
                this.ruleForm.content = data.content;
                this.ruleForm.enable = data.enable;
              }
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t5 = _context5.v;
              console.log(_t5);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function getBusinessCollege(_x4) {
        return _getBusinessCollege2.apply(this, arguments);
      }
      return getBusinessCollege;
    }()
  }
};